var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { Button, Loader } from "sb-resp-ui";
import { observer } from "mobx-react";
let ButtonControl = class ButtonControl extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-reality-check-dialog__control" },
            React.createElement(Button.Medium, { color: this.props.color, dataUat: this.props.dataUat, onClick: this.props.onClick, disabled: this.props.disabled }, this.props.disabled ? React.createElement(Loader, null) : this.props.title)));
    }
};
ButtonControl = __decorate([
    observer
], ButtonControl);
export { ButtonControl };
//# sourceMappingURL=ButtonControl.js.map